import * as React from "react";
import {
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Typography
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const ReleaseDetailsChecklist = props => {
    const { releaseDetail } = props;
    return (
        <List>
            <ReleaseDetailsChecklistItem
                title={"Eitri App"}
                value={releaseDetail.slug}
            />
            <ReleaseDetailsChecklistItem
                title={"Versão"}
                value={releaseDetail.version}
            />
            <ReleaseDetailsChecklistItem
                title={"Destino da Publicação"}
                value={releaseDetail.environment}
            />
        </List>
    );
};

const ReleaseDetailsChecklistItem = props => {
    const { title, value } = props;
    return (
        <ListItem disableGutters>
            <ListItemIcon>
                <CheckIcon />
            </ListItemIcon>
            <ListItemText>
                <Stack
                    spacing={1}
                    direction={{
                        xs: "column",
                        sm: "row"
                    }}
                >
                    <Typography variant="h6" fontWeight="600">
                        {title}:
                    </Typography>
                    <Typography variant="h6" fontWeight="400">
                        {value}
                    </Typography>
                </Stack>
            </ListItemText>
        </ListItem>
    );
};

export default ReleaseDetailsChecklist;
